<div class="settings-form">
  @if(isDataLoaded) {
    <app-page>
      <div class="top-cta">
        @if(selectedTab === SettingTabsModel.Subscription) {

          @if(hasSubscription && subscription) {
            <dx-button
              *ngIf="subscription.publishToSubscribers && subscription.isPrivatePublishing"
              [text]="'TENANT-SUBSCRIPTION.COPY-SUBSCRIPTION-LINK' | translate"
              type="default"
              (click)="onCopySubscriptionLink()"
            ></dx-button>

            <dx-button
              [text]="'TENANT-SUBSCRIPTION.UPDATE-PUBLISHING-DETAILS' | translate"
              type="normal"
              (click)="onUpdateSubscription()"
            ></dx-button>
          } @else {
            <dx-button
              [text]="'TENANT-SUBSCRIPTION.CREATE-PUBLISHING-DETAILS' | translate"
              type="normal"
              (click)="onCreateSubscription()"
            ></dx-button>
          }
        } @else if(
          selectedTab === SettingTabsModel.GeneralSettings || 
          selectedTab === SettingTabsModel.LicenseManagement ||
          selectedTab === SettingTabsModel.Domains || 
          selectedTab === SettingTabsModel.Login
        ) {
          <dx-button
            [text]="'COMMON.SAVE' | translate"
            type="normal"
            (click)="onFormSubmit()"
          ></dx-button>
        }
      </div>
      <app-page-title
        [title]="'SETTINGS.OVERVIEW.TITLE' | translate"
      ></app-page-title>
      <dx-tabs
        class="setting-tabs"
        width="100%"
        [selectedIndex]="selectedTab"
        [showNavButtons]="false"
        [dataSource]="tabs"
        (onItemClick)="onTabChange($event)"
      ></dx-tabs>
      <div [hidden]="selectedTab !== SettingTabsModel.GeneralSettings">
        <app-panel
          class="settings-panel"
          [title]="'COMMON.FIELDS.QUALIFICATION-TARGET' | translate"
        >
          <dx-form
            #qualificationForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="tenantUpdateModel"
          >
            <dxi-item itemType="group">
              <dxo-col-count-by-screen
                [xs]="1"
                [sm]="1"
                [md]="1"
                [lg]="2"
              ></dxo-col-count-by-screen>
              <dxi-item>
                <dxo-label [text]="'COMMON.FIELDS.AMOUNT' | translate"></dxo-label>
                <div *dxTemplate>
                  <app-time-picker
                    [isInvalid]="false"
                    (timeChanged)="handleIddTargetTimePicker($event)"
                    [defaultValue]="iddTargetAmount"
                  ></app-time-picker>
                </div>
              </dxi-item>
              <dxi-item
                [editorOptions]="qualificationTargetTypeOptions"
                dataField="qualificationTargetType"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.DEFINITION' | translate"
                ></dxo-label>
              </dxi-item>
              <dxi-item 
                *ngIf="!isIndividualBrokerTenant" 
                dataField="iddResponsiblePersonId" 
              >
                <div *dxTemplate>
                  <dx-drop-down-box
                    #iddDropDown
                    [(value)]="tenantUpdateModel.iddResponsiblePersonId"
                    [inputAttr]="{ 'aria-label': 'Owner' }"
                    valueExpr="id"
                    displayExpr="name"
                    [label]="('COMMON.FIELDS.IDD-RESPONSIBLE' | translate) + ' *'"
                    [dataSource]="employees"
                    labelMode="floating"
                    stylingMode="outlined"
                    [showClearButton]="true"
                    (onValueChanged)="iddDropDown.instance.close()"
                  >
                    <dx-validator validationGroup="customFields">
                      <dxi-validation-rule
                        type="required"
                        [message]="'VALIDATIONS.IDD-RESPONSIBLE-PERSON-REQUIRED' | translate">
                      ></dxi-validation-rule>
                    </dx-validator>
                    <div *dxTemplate="let data of 'content'">
                      <dx-tree-view
                        [searchEnabled]="true"
                        [dataSource]="employees"
                        keyExpr="id"
                        [selectNodesRecursive]="false"
                        displayExpr="name"
                        (onItemClick)="onIddResponsibleSelected($event)"
                      >
                      </dx-tree-view>
                    </div>
                  </dx-drop-down-box>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group">
              <dxo-col-count-by-screen
                [xs]="1"
                [sm]="1"
                [md]="1"
                [lg]="2"
              ></dxo-col-count-by-screen>
              <dxi-item
                editorType="dxCheckBox"
                dataField="sendTrainingProgressMail"
                [editorOptions]="{
                  text: 'SETTINGS.EMAIL-AUTOMATICALLY' | translate,
                  onValueChanged: onSendTrainingProgressMailChanged.bind(this)
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
              <dxi-item
                editorType="dxCheckBox"
                dataField="enableExternalCertificateApproval"
                [editorOptions]="{
                  text: 'SETTINGS.ENABLE-EXTERNAL-CERTIFICATE-APPROVAL' | translate
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
              <dxi-item
                *ngIf="showSendTrainingProgressMailToBrokers"
                editorType="dxCheckBox"
                dataField="sendTrainingProgressMailToBrokers"
                cssClass="nested-checkbox"
                [editorOptions]="{
                  text: 'SETTINGS.EMAIL-AUTOMATICALLY-TO-BROKERS' | translate
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
            </dxi-item>
            <dxi-item [colSpan]="2">
              <div *dxTemplate>
                <hr />
              </div>
            </dxi-item>
            <dxi-item itemType="group">
              <dxo-col-count-by-screen
                [xs]="1"
                [sm]="1"
                [md]="1"
                [lg]="2"
              ></dxo-col-count-by-screen>
              <dxi-item 
                [colSpan]="2"
                editorType="dxCheckBox"
                dataField="isIddEscalationEnabled"
                [editorOptions]="{
                  text: 'SETTINGS.IDD-ESCALATION.IDD-ESCALATION-ENABLED' | translate,
                  onValueChanged: onIddEscalationEnabledChanged.bind(this)
                }"
              >
                <dxo-label [visible]="false"> </dxo-label>
              </dxi-item>
              <dxi-item [colSpan]="1">
                <div *dxTemplate>
                  <div 
                    class="escalation-description-top"
                    [innerHTML]="
                      'SETTINGS.IDD-ESCALATION.IDD-ESCALATION-DESCRIPTION-TOP' | translate
                    "
                  ></div>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item
              itemType="group"
              *ngIf="tenantUpdateModel.isIddEscalationEnabled"
            >
              <dxo-col-count-by-screen
                [xs]="1"
                [sm]="1"
                [md]="1"
                [lg]="2"
              ></dxo-col-count-by-screen>

              <dxi-item [colSpan]="2">
                <div *dxTemplate>
                  <div class="idd-escalation-thresholds">
                    <app-idd-escalation-thresholds
                      #iddEscalationThresholds
                      [isIddEscalationEnabled]="tenantUpdateModel.isIddEscalationEnabled"
                      [(iddEscalationThresholds)]="tenantUpdateModel.iddEscalationThresholds"
                    ></app-idd-escalation-thresholds>
                  </div>
                </div>
              </dxi-item>
              <dxi-item
                itemType="simple"
                [colSpan]="1"
              >
                <div *dxTemplate>
                  <div
                    class="escalation-description-bottom"
                    [innerHTML]="
                      'SETTINGS.IDD-ESCALATION.IDD-ESCALATION-DESCRIPTION-BOTTOM'
                        | translate
                    "
                  ></div>
                </div>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </app-panel>
        <app-panel
          class="settings-panel segment-settings-panel"
          [title]="'COMMON.FIELDS.SEGMENT-SETTINGS' | translate"
        >
          <dx-form
            #segmentForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="tenantUpdateModel"
          >
            <dxi-item itemType="group">
              <dxo-col-count-by-screen
                [xs]="1"
                [sm]="1"
                [md]="1"
                [lg]="2"
              ></dxo-col-count-by-screen>
              <dxi-item
                [editorOptions]="segmentOptions"
                dataField="segment"
                editorType="dxSelectBox"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.MARKET-SEGMENT' | translate"
                ></dxo-label>
                <dxi-validation-rule
                  type="required"
                  [message]="'VALIDATIONS.MARKET-SEGMENT-REQUIRED' | translate">
                </dxi-validation-rule>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </app-panel>
        <app-panel class="settings-panel font-settings-panel">
          <div class="panel-title">
            {{ 'SETTINGS.CERTIFICATE-FONTS.TITLE' | translate }}
            <span class="new-badge">{{ 'COMMON.NEW' | translate }}</span>
          </div>
          <p 
            class="text-caption"
            [innerHTML]="'SETTINGS.CERTIFICATE-FONTS.DESCRIPTION' | translate"
          ></p>
          
          <dx-form
            #fontForm
            labelMode="floating"
            [showColonAfterLabel]="false"
            [formData]="tenantUpdateModel"
          >
            <dxi-item itemType="group">
              <dxo-col-count-by-screen
                [xs]="1"
                [sm]="1"
                [md]="1"
                [lg]="2"
              ></dxo-col-count-by-screen>

              <dxi-item
                dataField="certificateFontFamily"
                editorType="dxSelectBox"
                [editorOptions]="fontFamilyOptions"
              >
                <dxo-label 
                  [text]="'COMMON.FIELDS.FONT-FAMILY' | translate"
                ></dxo-label>
              </dxi-item>

              <dxi-item
                dataField="certificateFontSize"
                editorType="dxSelectBox"
                [editorOptions]="fontSizeOptions"
              >
                <dxo-label
                  [text]="'COMMON.FIELDS.FONT-SIZE' | translate"
                ></dxo-label>
              </dxi-item>
            </dxi-item>
          </dx-form>
        </app-panel>
      </div>
      <app-panel
        class="settings-panel"
        [title]="'SETTINGS.LICENSES' | translate"
        [hidden]="selectedTab !== SettingTabsModel.LicenseManagement"
      >
        <div
          *ngIf="isCreateMissingUsersRunning"
          class="alert alert-info d-flex align-items-center gap-2"
        >
          <i class="bi bi-hourglass-split"></i>
          {{ 'SETTINGS.CREATE-ACCOUNTS-RUNNING' | translate }}
        </div>
        <dx-form
          labelLocation="top"
          [showColonAfterLabel]="false"
          [formData]="tenantUpdateModel"
        >
          <dxi-item itemType="group" colCount="3">
            <dxi-item
              [colSpan]="1"
              editorType="dxCheckBox"
              dataField="createEmployeeAccounts"
              [editorOptions]="{
                text: 'SETTINGS.ACCOUNTS-EMPLOYEES' | translate
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
            <dxi-item [colSpan]="2" cssClass="missing-accounts-wrapper">
              <div *dxTemplate>
                <div class="missing-accounts" *ngIf="missingEmployeesData">
                  <div class="missing-accounts-count">
                    {{ missingEmployeesData.numberOfPersons }}
                    {{ "SETTINGS.PERSONS-WITHOUT-ACCOUNT" | translate }}
                  </div>
                  <dx-button
                    [text]="'SETTINGS.CREATE-ACCOUNTS' | translate"
                    type="normal"
                    [disabled]="isCreateMissingUsersRunning"
                    (click)="registerMissingAccounts(missingEmployeesData.roleId)"
                  ></dx-button>
                </div>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" colCount="3">
            <dxi-item
              [colSpan]="1"
              cssClass="checkboxes-wrapper"
              editorType="dxCheckBox"
              dataField="createManagerAccounts"
              [editorOptions]="{
                text: 'SETTINGS.ACCOUNTS-MANAGERS' | translate
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
            <dxi-item [colSpan]="2" cssClass="missing-accounts-wrapper">
              <div *dxTemplate>
                <div class="missing-accounts" *ngIf="missingManagersData">
                  <div class="missing-accounts-count">
                    {{ missingManagersData.numberOfPersons }}
                    {{ "SETTINGS.PERSONS-WITHOUT-ACCOUNT" | translate }}
                  </div>
                  <dx-button
                    [text]="'SETTINGS.CREATE-ACCOUNTS' | translate"
                    type="normal"
                    [disabled]="isCreateMissingUsersRunning"
                    (click)="registerMissingAccounts(missingManagersData.roleId)"
                  ></dx-button>
                </div>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" colCount="3">
            <dxi-item
              [colSpan]="1"
              cssClass="checkboxes-wrapper"
              editorType="dxCheckBox"
              dataField="createTrainerAccounts"
              [editorOptions]="{
                text: 'SETTINGS.ACCOUNTS-TRAINERS' | translate
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
            <dxi-item [colSpan]="2" cssClass="missing-accounts-wrapper">
              <div *dxTemplate>
                <div class="missing-accounts" *ngIf="missingTrainersData">
                  <div class="missing-accounts-count">
                    {{ missingTrainersData.numberOfPersons }}
                    {{ "SETTINGS.PERSONS-WITHOUT-ACCOUNT" | translate }}
                  </div>
                  <dx-button
                    [text]="'SETTINGS.CREATE-ACCOUNTS' | translate"
                    type="normal"
                    [disabled]="isCreateMissingUsersRunning"
                    (click)="registerMissingAccounts(missingTrainersData.roleId)"
                  ></dx-button>
                </div>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" colCount="3">
            <dxi-item
              [colSpan]="1"
              cssClass="checkboxes-wrapper"
              editorType="dxCheckBox"
              dataField="createSuperAdminAccounts"
              [editorOptions]="{
                text: 'SETTINGS.ACCOUNTS-SUPERADMINS' | translate
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
            <dxi-item [colSpan]="2" cssClass="missing-accounts-wrapper">
              <div *dxTemplate>
                <div class="missing-accounts" *ngIf="missingSuperAdminsData">
                  <div class="missing-accounts-count">
                    {{ missingSuperAdminsData.numberOfPersons }}
                    {{ "SETTINGS.PERSONS-WITHOUT-ACCOUNT" | translate }}
                  </div>
                  <dx-button
                    [text]="'SETTINGS.CREATE-ACCOUNTS' | translate"
                    type="normal"
                    [disabled]="isCreateMissingUsersRunning"
                    (click)="registerMissingAccounts(missingSuperAdminsData.roleId)"
                  ></dx-button>
                </div>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" colCount="3">
            <dxi-item
              [colSpan]="1"
              cssClass="checkboxes-wrapper"
              editorType="dxCheckBox"
              dataField="createBrokerAccounts"
              [editorOptions]="{
                text: 'SETTINGS.ACCOUNTS-BROKERS' | translate
              }"
            >
              <dxo-label [visible]="false"> </dxo-label>
            </dxi-item>
            <dxi-item [colSpan]="2" cssClass="missing-accounts-wrapper">
              <div *dxTemplate>
                <div class="missing-accounts" *ngIf="missingBrokersData">
                  <div class="missing-accounts-count">
                    {{ missingBrokersData.numberOfPersons }}
                    {{ "SETTINGS.PERSONS-WITHOUT-ACCOUNT" | translate }}
                  </div>
                  <dx-button
                    [text]="'SETTINGS.CREATE-ACCOUNTS' | translate"
                    type="normal"
                    [disabled]="isCreateMissingUsersRunning"
                    (click)="registerMissingAccounts(missingBrokersData.roleId)"
                  ></dx-button>
                </div>
              </div>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </app-panel>
      <app-panel
        class="settings-panel"
        [title]="'SETTINGS.DOMAINS-TITLE' | translate"
        [hidden]="selectedTab !== SettingTabsModel.Domains"
      >
        <span class="settings-description">{{ "SETTINGS.DOMAINS-DESCRIPTION" | translate }}</span>
        <dx-form>
          <dxi-item itemType="group" colCount="3">
            <dxi-item [colSpan]="3" cssClass="missing-accounts-wrapper">
                <div *dxTemplate>
                    <div class="w-100">
                        <dx-tag-box
                          [items]="tenantUpdateModel.domains"
                          [(value)]="tenantUpdateModel.domains"
                          [acceptCustomValue]="true"
                          [inputAttr]="{ 'aria-label': 'Domain' }"
                          [openOnFieldClick]="false"
                        >
                          <div *dxTemplate="let tagData of 'tagTemplate'" class="dx-tag-content">
                            TAG CONTENT
                            <div class="dx-tag-remove-button">qwe</div>
                          </div>
                        </dx-tag-box>
                    </div>
                </div>
            </dxi-item>
          </dxi-item>
        </dx-form>
      </app-panel>
      <app-panel
        [hidden]="selectedTab !== SettingTabsModel.Subscription"
        class="settings-panel"
        [title]="(
          hasSubscription 
            ? 'TENANT-SUBSCRIPTION.EDIT-SUBSCRIPTION-TITLE' 
            : 'TENANT-SUBSCRIPTION.CREATE-SUBSCRIPTION-TITLE'
          ) | translate
        "
      >
        <div class="row">
          <div class="col-md-12 col-lg-5">
            <app-panel class="avatar-panel">
              <div id="avatar-upload" class="uploader-container">
                @if(subscriptionImage || subscription?.file){
                  <img
                    class="avatar-img"
                    [src]="subscriptionImage || subscription?.file?.fileUrl"
                    title="Logo"
                  />
                } @else {
                  <div
                    class="uploader-preview-container"
                  >
                    <img src="assets/img/upload.jpg" title="Upload"/>
                    <span class="preview-title">{{
                      "COMMON.UPLOAD-IMAGE" | translate
                    }}</span>
                    <span class="preview-description">{{
                      "COMMON.UPLOAD-IMAGE-SIZE" | translate
                    }}</span>
                  </div>
                }
              </div>
              <dx-file-uploader
                #fileUploader
                dialogTrigger="#avatar-upload"
                dropZone="#avatar-upload"
                [multiple]="false"
                [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
                uploadMode="useForm"
                [visible]="false"
                (valueChange)="onSubscriptionImageUploaded($event)"
              ></dx-file-uploader>
            </app-panel>
          </div>
          <div class="col-md-12 col-lg-7">
            <app-panel class="subscription-panel">
              <dx-form
                #subscriptionForm
                labelMode="floating"
                [showColonAfterLabel]="false"
                [formData]="subscriptionUpdateModel"
              >
                <dxi-item dataField="name">
                  <dxo-label [text]="'COMMON.FIELDS.NAME' | translate"></dxo-label>
                  <dxi-validation-rule
                    type="required"
                    [message]="'VALIDATIONS.NAME-REQUIRED' | translate"
                  ></dxi-validation-rule>
                </dxi-item>
                <dxi-item
                  dataField="description"
                  editorType="dxTextArea"
                  cssClass="description-control"
                >
                  <dxo-label
                    [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
                  ></dxo-label>
                  <dxi-validation-rule
                    type="required"
                    [message]="'VALIDATIONS.DESCRIPTION-REQUIRED' | translate"
                  ></dxi-validation-rule>
                </dxi-item>
                <dxi-item
                  editorType="dxCheckBox"
                  dataField="isPrivatePublishing"
                  [editorOptions]="{
                    text: 'TENANT-SUBSCRIPTION.ENABLE-PRIVATE-PUBLISHING-MODE' | translate
                  }"
                >
                  <dxo-label [visible]="false"></dxo-label>
                </dxi-item>
              </dx-form>
              <div class="publishing-mode-container">
                @if(subscriptionUpdateModel.publishToSubscribers){
                  <dx-button
                    [text]="'TENANT-SUBSCRIPTION.DEACTIVATE-PUBLISHING-MODE' | translate"
                    type="danger"
                    stylingMode="contained"
                    (onClick)="deactivatePublishingMode()"
                  ></dx-button>
                } @else {
                  <dx-button
                    [text]="'TENANT-SUBSCRIPTION.ACTIVATE-PUBLISHING-MODE' | translate"
                    type="normal"
                    stylingMode="contained"
                    (onClick)="activatePublishingMode()"
                  ></dx-button>
                }
              </div>
            </app-panel>
          </div>
        </div>
      </app-panel>
      <div
        class="settings-panel"
        [hidden]="selectedTab !== SettingTabsModel.Login"
      >
        <app-panel class="settings-panel">
          <dx-button
            [text]="'COMMON.LOGIN-PREVIEW' | translate"
            type="default"
            (click)="openPreviewLogin()"
          ></dx-button>

          <div class="row g-3">
            <div class="col-md-12 col-lg-8">
              <app-panel 
                [title]="'COMMON.FIELDS.LOGIN-BACKGROUND' | translate"
              >
                <div id="login-background-upload" class="uploader-container">
                  @if(loginBackgroundImage || tenant.loginBackgroundFile){
                    <img
                      class="avatar-img"
                      [src]="loginBackgroundImage || tenant.loginBackgroundFile!.fileUrl"
                      title="Logo"
                    />
                  } @else {
                    <div
                      class="uploader-preview-container"
                    >
                      <img src="assets/img/upload.jpg" title="Upload"/>
                      <span class="preview-title">{{
                        "COMMON.UPLOAD-IMAGE" | translate
                      }}</span>
                      <span class="preview-description">{{
                        "COMMON.UPLOAD-IMAGE-SIZE" | translate
                      }}</span>
                    </div>
                  }
                </div>
                <dx-file-uploader
                  #backgroundUploader 
                  dialogTrigger="#login-background-upload"
                  dropZone="#login-background-upload"
                  [multiple]="false"
                  [allowedFileExtensions]="['.jpg', '.jpeg', '.png']"
                  uploadMode="useForm"
                  [visible]="false"
                  (valueChange)="onLoginBackgroundImageUploaded($event)"
                ></dx-file-uploader>
              </app-panel>
            </div>
            <div class="col-md-12 col-lg-4">
              <app-panel 
                [title]="'COMMON.FIELDS.LOGIN-LOGO' | translate"
              >
                <div id="login-logo-upload" class="uploader-container">
                  @if(loginLogoImage || tenant.loginLogoFile){
                    <img
                      class="avatar-img"
                      [src]="loginLogoImage || tenant.loginLogoFile!.fileUrl"
                      title="Logo"
                    />
                  } @else {
                    <div
                      class="uploader-preview-container"
                    >
                      <img src="assets/img/upload.jpg" title="Upload"/>
                      <span class="preview-title">{{
                        "COMMON.UPLOAD-IMAGE" | translate
                      }}</span>
                      <span class="preview-description">{{
                        "COMMON.UPLOAD-IMAGE-SIZE" | translate
                      }}</span>
                    </div>
                  }
                </div>
                <dx-file-uploader
                  #logoUploader
                  dialogTrigger="#login-logo-upload"
                  dropZone="#login-logo-upload"
                  [multiple]="false"
                  [allowedFileExtensions]="['.jpg', '.jpeg', '.png']"
                  uploadMode="useForm"
                  [visible]="false"
                  (valueChange)="onLoginLogoImageUploaded($event)"
                ></dx-file-uploader>
              </app-panel>
              <dx-form
                labelMode="floating"
                [showColonAfterLabel]="false"
                [formData]="tenantUpdateModel"
              >
                <dxi-item dataField="defaultLocationId">
                  <div *dxTemplate>
                    <dx-drop-down-box
                      #defaultLocationDropDown
                      [(value)]="tenantUpdateModel.defaultLocationId"
                      valueExpr="id"
                      displayExpr="name"
                      [label]="'COMMON.FIELDS.DEFAULT-LOCATION' | translate"
                      [dataSource]="locations"
                      labelMode="floating"
                      stylingMode="outlined"
                      [showClearButton]="true"
                      (onValueChanged)="defaultLocationDropDown.instance.close()"
                    >
                      <div *dxTemplate="let data of 'content'">
                        <dx-tree-view
                          [searchEnabled]="true"
                          [dataSource]="locations"
                          keyExpr="id"
                          dataStructure="plain"
                          [selectNodesRecursive]="false"
                          displayExpr="name"
                          (onItemClick)="onDefaultLocationSelected($event.itemData?.id)"
                        ></dx-tree-view>
                      </div>
                    </dx-drop-down-box>
                  </div>
                </dxi-item>
              </dx-form>
            </div>

          </div>
        </app-panel>
        <app-panel 
          *ngIf="isTopLevelSuperAdmin"
          class="login-fields-settings-panel"
        >
          <div class="guest-fields-header-container">
            <h2 class="guest-fields-title">
              {{ 'GUEST-FORM-FIELDS.TITLE' | translate }}
            </h2>
            <p class="guest-fields-description">
              {{ 'GUEST-FORM-FIELDS.DESCRIPTION' | translate }}
            </p>
          </div>
          <div class="guest-fields-container">
            <app-registration-field-config
              #registrationFieldConfigs 
              [formLabel]="'MY-INVITATION.LOGIN' | translate"
              [fields]="registrationFields"
            ></app-registration-field-config>
          </div>
        </app-panel>
      </div>
    </app-page>
  }
</div>

@if(showActivatePublishingModeModal) {
  <app-activate-publishing-mode-modal
    [hasSubscription]="hasSubscription"
    [(showModal)]="showActivatePublishingModeModal"
    [(publishToSubscribers)]="subscriptionUpdateModel.publishToSubscribers"
    (onActivate)="onActivatedPublishingMode()"
  />
}

@if(showDeactivatePublishingModeModal) {
  <app-deactivate-publishing-mode-modal
    [hasSubscription]="hasSubscription"
    [(showModal)]="showDeactivatePublishingModeModal"
    [(publishToSubscribers)]="subscriptionUpdateModel.publishToSubscribers"
    (onDeactivate)="onDeactivatedPublishingMode()"
  />
}

@if(showPreviewLoginModal) {
  <dx-popup
    [(visible)]="showPreviewLoginModal"
    [title]="'COMMON.LOGIN-PREVIEW' | translate"
    [width]="1200"
    [height]="700"
    [dragEnabled]="false"
    [hideOnOutsideClick]="true"
    [showCloseButton]="true"
  >
    <app-login
      [previewMode]="true"
      [previewBackgroundUrl]="loginBackgroundImage || tenant.loginBackgroundFile?.fileUrl"
      [previewLogoUrl]="loginLogoImage || tenant.loginLogoFile?.fileUrl"
    ></app-login>
  </dx-popup>
}

<app-publishing-mode-required-modal
  [(showModal)]="showPublishingModeRequiredModal"
></app-publishing-mode-required-modal>